module.exports = __webpack_public_path__ + "common/icon-sg-flag-37a84208a8f63ea0bc9b2de239d78ac0.svg";